<mat-form-field class="relative percent-wrapper"
                [ngClass]="inputClass"
                appearance="outline"
                [hideRequiredMarker]="true"
                floatLabel="always"
                [class.mat-form-field-invalid]="ctrl?.invalid && ctrl?.touched"
                [class.mb-1]="ctrl?.invalid && ctrl?.touched">
  <span aria-hidden="true"
        class="prefix d-flex jc-center ai-center">&#37;</span>
  <mat-label [hidden]="hideLabel">
    <span>{{inputLabel}}</span>
    <span *ngIf="isRequired" class="color-error">*</span>:
  </mat-label>
  <input matInput #input
         [placeholder]="placeholder"
         type="text"
         [formControl]="ctrl.control"
         class="app-input"
         data-lpignore="true"
         [style.margin-left]="'26px'"
         [required]="isRequired"
         [readonly]="readonly"
         [errorStateMatcher]="errorMatcher()"
         [attr.data-test-id]="'input_currency_'+testId"
         appAutonumeric [options]="currencyControlOptions">
  <mat-hint class="hint d-flex ai-end" *ngIf="inputHint && !isWarningVisible">
    <span class="icon icon-info mr-q"></span> {{inputHint}}</mat-hint>

  <mat-hint *ngIf="isWarningVisible" class="color-warning d-flex ai-center">
    <span class="icon icon-error icon-fs-md mr-q"></span>
    <span class="fs-sm">{{warningMessage}}</span>
  </mat-hint>

  <mat-error *ngIf="ctrl?.invalid && ctrl?.touched">
    <span class="icon icon-error fs-md"></span> {{getErrorMessage()}}</mat-error>
</mat-form-field>
